import React from 'react'

const idPart = value =>
    String(value === undefined || value === null ? '' : value)
        .trim()
        .replace(/[^A-Za-z0-9_-]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'field'

export const fieldErrorId = (sectionId, fieldName) =>
    `${idPart(sectionId)}-${idPart(fieldName)}-error`

export const fieldErrorAttributes = ({ sectionId, fieldName, error, describedBy }) => {
    if (!error) return describedBy ? { 'aria-describedby': describedBy } : {}
    const errorId = fieldErrorId(sectionId, fieldName)
    return {
        'aria-invalid': true,
        'aria-describedby': [describedBy, errorId].filter(Boolean).join(' '),
    }
}

export const FieldValidationError = ({ sectionId, fieldName, error, className }) => {
    if (!error) return null
    return (
        <p id={fieldErrorId(sectionId, fieldName)} className={className}>
            <span aria-hidden="true">⚠ </span>
            {`Error: ${error}`}
        </p>
    )
}
